import Operation from './Operation';

export default class Division extends Operation {
  cal (a, b) {
    a = Number(a);
    b = Number(b);
    return a / b;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Division.js